module.exports = "/images/transnistria.svg?142947b7c10f209b6c9087a46df800b4";